import { Injectable } from '@angular/core';
import { OfbizListService } from './ofbiz-list.service';

@Injectable({
  providedIn: 'root'
})
export class TableFactoryService {
  defaultSettings:any = {
    hideSubHeader: true,
    mode:'external',
    add: {
      addButtonContent: '<i class="nb-plus table-action"></i>',
      createButtonContent: '<i class="nb-checkmark table-action"></i>',
      cancelButtonContent: '<i class="nb-close table-action"></i>',
    },
    edit: {
      editButtonContent: '<img src="assets/images/icons/outline/edit-2-outline.svg" class="custom-icon">',
      saveButtonContent: '<i class="nb-checkmark table-action"></i>',
      cancelButtonContent: '<i class="nb-close table-action"></i>',
    },
    delete: {
      deleteButtonContent: '<img src="assets/images/icons/outline/trash-2-outline.svg" class="custom-icon">',
      confirmDelete: true,
    },
    filter:false,
    pager:{
      display:false,
      perPage:50
    },
  }
  
  constructor(private ofbizListService:OfbizListService) { }
  /**
   * 
   * @param columnFields 
   * @param fieldOptions 
   * @param listOptions 
   * @param isLookup 
   * @param isMulti 
   * @returns Settings defining the columns and actions
   */
  createTable(columnFields:any,fieldOptions:any,listOptions:any,isLookup:boolean,isMulti:boolean):any{
    let settings:any = {};
    if(isMulti){
      settings["selectMode"] = "multi";
    }
    if(columnFields){
      //console.log({Action:"createTable",TrackColumnFields:this.columnFields});
      settings["columns"] = this.ofbizListService.createColumns(columnFields,fieldOptions,listOptions,isLookup,isMulti);
      settings["mode"] = this.setMode(columnFields,isMulti);
    }
    settings["hideSubHeader"] = this.defaultSettings.hideSubHeader;
    
    //this.settings["mode"] = this.defaultSettings.mode;
    settings["add"] = this.defaultSettings.add;
    settings["edit"] = this.defaultSettings.edit;
    settings["delete"] = this.defaultSettings.delete;
    settings["pager"] = this.defaultSettings.pager;
    settings["actions"] = this.setActions(isMulti,settings["columns"],columnFields);
    if(settings["mode"] === "inline" && settings.actions.edit == true){
      settings.edit["confirmSave"] = true;
    }
    if(settings["mode"] === "inline" && settings.actions.add == true){
      settings.add["confirmCreate"] = true;
    }
    console.log({SettingBeforeLoad:settings});
    return settings
  }

  setActions(isMulti:boolean,columns:any,columnFields:any[]){
      let config = {position:null,edit:false,delete:false,add:false};
      if(isMulti){
        config.add = true;
      }
      
      Object.entries(columns).forEach(([key, value]) => {
        //console.log({"TrackKeyValue":{key:key,value:value}});
        if(value["editable"] != undefined && value["editable"] == true){
          config.edit = true;
          config.position = "right";
        }

      });
      for(let field of columnFields){
        if(field.name && (field.name === "deleteLink" || field.name.includes("remove"))){
          console.log({DeleteLinkFound:field.name});
          config.delete = true;
        }
      }
      console.log({"Config":config});
      return config;
  }

  setMode(columnFields:any,isMulti:boolean):string{
      let mode = "external";
      for(let field of columnFields){
        //console.log({TrackFieldType:{field:field}});
        if(field["type"] === "submit" || field["type"] === "SUBMIT" || isMulti){
          mode = "inline";
          break
        }
      }
      return mode
  }
}
